import React, { useState } from "react";
import session from "../services/session";
import moment from "moment";
import { swalDeleteForm } from "../utils/swal";

import "./CommentBox.scss";
import TextAreaMention2 from "./TextAreaMention/TextAreaMention2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components/macro";

function formatTimeAgo(commentDate) {
  const now = moment();
  const durationInSeconds = now.diff(commentDate, "seconds");

  if (durationInSeconds < 60) {
    return `${durationInSeconds}s`;
  }

  const durationInMinutes = now.diff(commentDate, "minutes");
  if (durationInMinutes < 60) {
    return `${durationInMinutes}m`;
  }

  const durationInHours = now.diff(commentDate, "hours");
  if (durationInHours < 24) {
    return `${durationInHours}h`;
  }

  const durationInDays = now.diff(commentDate, "days");
  return `${durationInDays}d`;
}

export default function CommentBox(props) {
  const [isEdit, setIsEdit] = useState(false);
  const [isEditReply, setIsEditReply] = useState({
    open: false,
    id: "",
  });
  const [isReply, setIsReply] = useState(false);
  const [comment, setComment] = useState(props.comment.text);
  const [commentReply, setCommentReply] = useState("");
  const [reply, setReply] = useState("");

  const handleEdit = (e) => {
    if (isEdit) {
      return;
    }
    e.preventDefault();
    setIsEdit(true);
  };

  const handleEditReply = (e, id) => {
    // e.preventDefault();
    setIsEditReply({
      open: true,
      id
    });
    setCommentReply(e);
  };

  const handleReply = (e) => {
    e.preventDefault();
    // if (props.comment?.replies?.length > 0) return;
    setIsReply(true);
  };

  const onSubmitEdit = (e) => {
    const obj = {
      id: props.comment._id,
      text: comment,
    };
    setIsEdit(false);

    props.setCommentToUpdate(e, obj);
  };

  const onSubmitEditReply = (e, id) => {
    const obj = {
      id: id,
      text: commentReply,
      rootId: props.comment._id,
    };
    setIsEditReply({
      open: false,
      id: ""
    });

    props.setCommentToUpdate(e, obj);
  };

  const onSubmitReply = (e) => {
    const obj = {
      id: props.comment._id,
      text: reply,
    };
    setIsReply(false);
    setReply("");

    props.setCommentToReply(e, obj);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    swalDeleteForm(() => {
      props.deleteComment(props.comment._id);
    });
  };

  const handleDeleteReply = (id) => {
    swalDeleteForm(() => {
      props.deleteComment(id, props.comment._id);
    });
  };

  const replacePattern = (text) => {
    // Regular expression to find the pattern
    const pattern = /\[\[({.*?})\]\]/g;

    return text.replace(pattern, (match) => {
      // Remove the surrounding brackets and parse the JSON
      const jsonString = match.slice(2, -2);
      const data = JSON.parse(jsonString);

      const { title } = data;

      // Create the replacement HTML
      return `
        <span class="avatar-user">
          ${title?.match(/\b(\w)/g)?.join("")}
        </span>
        <span>${title}</span>
      `;
    });
  };

  const renderComment = (comment, isRoot) => (
    <CommentHeader>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CommentAvatar>
          {comment.userId?.fullname
            ?.match(/\b(\w)/g)
            ?.join("")
            .slice(0, 2)}
        </CommentAvatar>

        <div>
          <span
            style={{
              color: "#fff",
              fontSize: "13px",
              marginRight: "4px",
            }}
          >
            {comment.userId && comment.userId.fullname}
          </span>
          <span
            style={{
              color: "rgba(189,192,212,.71)",
              fontSize: "12px",
            }}
          >
            {formatTimeAgo(comment.date)}
            {/* {moment(comment.date).fromNow()} */}
          </span>
        </div>
      </div>
      {/* {isRoot && ( */}
      <div>
        {session.get("user")._id === comment.userId._id && (
          <Actions className="actions">
            <Action>
              <FontAwesomeIcon
                icon={faPen}
                size="xs"
                onClick={
                  isRoot ? handleEdit : () => handleEditReply(comment.text, comment._id)
                }
              />
            </Action>
            <Action>
              <FontAwesomeIcon
                icon={faTrashAlt}
                size="xs"
                onClick={
                  isRoot ? handleDelete : () => handleDeleteReply(comment._id)
                }
              />
            </Action>
          </Actions>
        )}
      </div>
      {/* )} */}
    </CommentHeader>
  );

  return (
    <Wrapper
      onClick={() => props.setActiveComment(props.comment._id)}
      isActive={props.activeComment === props.comment._id}
    >
      {renderComment(props.comment, true)}

      <Wrap isHaveReply={props.comment?.replies?.length > 0}>
        {isEdit ? (
          <form>
            <input
              type="hidden"
              id="txt-edit-comment-id"
              value={props.comment._id}
            />
            <TextAreaMention2
              value={comment}
              setComment={setComment}
              onSubmit={onSubmitEdit}
              onCancel={() => {
                setIsEdit(false);
                setComment(props.comment.text);
              }}
              memberList={props.memberList}
            />
            <div className="invalid-feedback text-left">
              Please provide a text.
            </div>
          </form>
        ) : (
          <div>
            <CommentContent
              dangerouslySetInnerHTML={{
                __html: replacePattern(props.comment.text)?.replace(
                  /\n/g,
                  "<br />"
                ),
              }}
            />

            <ReplyButton
              style={{
                paddingBottom: props.comment?.replies?.length > 0 ? "12px" : 0,
              }}
              onClick={handleReply}
            >
              Reply
            </ReplyButton>
          </div>
        )}
      </Wrap>

      {props.comment?.replies?.length > 0 &&
        props.comment.replies.map((reply) => (
          <ReplyComment isReply={isReply}>
            {renderComment(reply, false)}

            {isEditReply.open && isEditReply.id == reply._id ? (
              <form>
                <input
                  type="hidden"
                  id="txt-edit-comment-id"
                  value={props.comment._id}
                />
                <TextAreaMention2
                  value={commentReply}
                  setComment={setCommentReply}
                  onSubmit={(e) => onSubmitEditReply(e, reply._id)}
                  onCancel={() => {
                    setIsEditReply({
                      open: false,
                      id: "",
                    });
                    setCommentReply(reply.text);
                  }}
                  memberList={props.memberList}
                />
                <div className="invalid-feedback text-left">
                  Please provide a text.
                </div>
              </form>
            ) : (
              <div>
                <CommentContent
                  dangerouslySetInnerHTML={{
                    __html: replacePattern(reply.text)?.replace(
                      /\n/g,
                      "<br />"
                    ),
                  }}
                />

                <ReplyButton onClick={handleReply}>Reply</ReplyButton>
              </div>
            )}
          </ReplyComment>
        ))}

      {isReply && (
        <form>
          <input
            type="hidden"
            id="txt-reply-comment-id"
            value={props.comment._id}
          />
          <TextAreaMention2
            value={reply}
            setComment={setReply}
            onSubmit={onSubmitReply}
            memberList={props.memberList}
            onCancel={() => {
              setIsReply(false);
              setReply("");
            }}
            isReply={true}
          />
          <div className="invalid-feedback text-left">
            Please provide a text.
          </div>
        </form>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 12px;
  background: ${(props) => (props.isActive ? "#1f2332" : "rgba(85,88,110,.4)")};
  border-radius: 8px;
  border: ${(props) =>
    props.isActive ? "1px solid #4c5067" : "1px solid transparent"};
  transition: all 0.3s ease;
  position: relative;

  .actions {
    opacity: ${(props) => (props.isActive ? 1 : 0)};
    visibility: ${(props) => (props.isActive ? "visible" : "hidden")};
    transition: all 0.3s ease;
  }

  &:hover {
    .actions {
      opacity: 1;
      visibility: visible;
    }
  }

  :first-child {
    margin-top: 0;
  }
`;

const Wrap = styled.div`
  position: relative;

  :after {
    content: "";
    position: absolute;
    top: -6px;
    left: 11px;
    width: 2px;
    height: calc(100% + 18px);
    background: rgba(85, 88, 110, 0.4);
    display: ${(props) => (props.isHaveReply ? "block" : "none")};
  }
`;

const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const CommentAvatar = styled.div`
  background: linear-gradient(
      160deg,
      hsla(0, 0%, 100%, 0.15) 0%,
      transparent 83.3%
    ),
    #00bfc0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  z-index: 10;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const Action = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  padding: 4px;
  border: 1px solid rgba(161, 164, 190, 0.65);

  svg {
    color: rgba(161, 164, 190, 0.65);
  }

  &:hover {
    background: rgba(109, 113, 136, 0.5);
    border: 1px solid rgba(109, 113, 136, 0.5);
  }
`;

const CommentContent = styled.div`
  padding-bottom: 4px;
  color: rgba(243, 243, 247, 0.9);
  font-size: 13px;
  margin-left: 36px;
`;

const ReplyButton = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(243, 243, 247, 0.9);
  margin-left: 36px;
  width: fit-content;
  cursor: pointer;

  &:hover {
    color: rgba(212, 214, 230, 0.75);
  }
`;

const ReplyComment = styled.div`
  padding: 12px 0;
  position: relative;

  :after {
    content: "";
    position: absolute;
    top: 37px;
    left: 11px;
    width: 2px;
    height: 100%;
    background: rgba(85, 88, 110, 0.4);
    display: ${(props) => (!props.isReply ? "block" : "none")};
  }

  :last-child {
    :after {
      display: none;
    }
  }
`;
